import { render } from "./DocumentosFilial.vue?vue&type=template&id=c0ea1b4c&scoped=true"
import script from "./DocumentosFilial.vue?vue&type=script&lang=js"
export * from "./DocumentosFilial.vue?vue&type=script&lang=js"

import "./DocumentosFilial.vue?vue&type=style&index=0&id=c0ea1b4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0ea1b4c"]])

export default __exports__